import * as types from "./actionType";

const initialState = {
  allUserStatus: false,
  allUser: [],
  ridesMembershipStatus: false,
  ridesMembership: [],
  ridesMembershipCount: 0,
  singleRidesMembershipStatus: false,
  singleRidesMembership: null,
  approvingRidesMembershipStatus: false,
  allRides: [],
  allReview: [],
  allRidesStatus: false,
  singleRide: null,
  singleRideStatus: false,
  createRideStatus: false,
  deleteRideStatus: false,
  updateRideStatus: false,
  consentFormStatus: false,
  consentForm: null,
  countryStatus: false,
  branchStatus: false,
  countries: [],
  reviewCountriesStatus: false,
  reviewCountries: [],
  branchesForReviewsStatus: false,
  branchesForReviews: [],
  stateStatus: false,
  states: [],
  cityStatus: false,
  cities: [],
  updateVinStatus: false,
  ridesForModerationStatus: false,
  ridesForModeration: [],
  reviewForModeration: [],
  reviewFilterForModeration: [],
  reviewFilterForModerationStatus: false,
  moderateRidesStatus: false,
  usersToJoinRideStatus: false,
  usersToJoinRide: [],
  moderationStatusForUser: false,
  joinNewUserStatus: false,
  exportToExcelStatus: false,
  exportToExcelForReviewStatus: false,
  rideImagesForModerationStatus: false,
  rideImagesForModeration: [],
  rideImageCountries: [],
  moderateImageStatus: false,
  rideImageBranches: [],
  rideImagesBranchesStatus: false,
  moderateImage: null,
  activityForReview: [],
  activityForGallery: [],
  moderateRideGalleyStatus: false,
};

function ridesReducers(state = initialState, action) {
  switch (action.type) {
    case types.CLEAR_PREVIOUS_REDUCERS:
      return {
        ...state,
        allUserStatus: false,
        allUser: [],
        ridesMembership: [],
        rideImageBranches: [],
        activityForGallery: [],
        ridesMembershipCount: 0,
      };
    case types.FETCH_RIDES_MEMBERSHIP:
      return {
        ...state,
        ridesMembershipStatus: true,
      };
    case types.FETCH_RIDES_MEMBERSHIP_SUCCESS: {
      return {
        ...state,
        ridesMembershipStatus: false,
        ridesMembership: [...state.ridesMembership, ...action.payload],
        ridesMembershipCount: action.count,
      };
    }
    case types.FETCH_RIDES_MEMBERSHIP_FAILED: {
      return {
        ...state,
        ridesMembershipStatus: false,
        ridesMembership: [],
      };
    }
    case types.FETCH_SINGLE_RIDE_MEMBERSHIP:
      return {
        ...state,
        singleRidesMembershipStatus: true,
        singleRidesMembership: null,
      };
    case types.FETCH_SINGLE_RIDE_MEMBERSHIP_SUCCESS: {
      return {
        ...state,
        singleRidesMembershipStatus: false,
        singleRidesMembership: action.payload,
      };
    }
    case types.FETCH_SINGLE_RIDE_MEMBERSHIP_FAILED: {
      return {
        ...state,
        singleRidesMembershipStatus: false,
        singleRidesMembership: null,
      };
    }

    case types.UPDATE_USER_VIN:
      return {
        ...state,
        updateVinStatus: true,
      };
    case types.UPDATE_USER_VIN_SUCCESS: {
      return {
        ...state,
        updateVinStatus: false,
      };
    }
    case types.UPDATE_USER_VIN_FAILED: {
      return {
        ...state,
        updateVinStatus: false,
      };
    }

    case types.APPROVE_RIDE_MEMBERSHIP:
      return {
        ...state,
        approvingRidesMembershipStatus: true,
      };
    case types.APPROVE_RIDE_MEMBERSHIP_SUCCESS: {
      return {
        ...state,
        approvingRidesMembershipStatus: false,
      };
    }
    case types.APPROVE_RIDE_MEMBERSHIP_FAILED: {
      return {
        ...state,
        approvingRidesMembershipStatus: false,
      };
    }

    case types.FETCH_ALL_RIDES:
      return {
        ...state,
        allRides: [],
        allRidesStatus: true,
      };

    case types.FETCH_ALL_RIDES_SUCCESS: {
      return {
        ...state,
        allRides: action.payload,
        allRidesStatus: false,
      };
    }

    case types.FETCH_ALL_RIDES_FAILED: {
      return {
        ...state,
        allRides: [],
        allRidesStatus: false,
      };
    }

    case types.FETCH_ALL_REVIEW:
      return {
        ...state,
        allReview: [],
        allReviewStatus: true,
      };

    case types.FETCH_ALL_REVIEW_SUCCESS: {
      return {
        ...state,
        allReview: action.payload,
        allReviewStatus: false,
      };
    }
    case types.FETCH_ALL_REVIEW_FAILED: {
      return {
        ...state,
        allReview: [],
        allReviewStatus: false,
      };
    }

    case types.FETCH_SINGLE_RIDE:
      return {
        ...state,
        singleRide: null,
        singleRideStatus: true,
      };

    case types.FETCH_SINGLE_RIDE_SUCCESS: {
      return {
        ...state,
        singleRide: action.payload,
        singleRideStatus: false,
      };
    }
    case types.FETCH_SINGLE_RIDE_FAILED: {
      return {
        ...state,
        singleRide: null,
        singleRideStatus: false,
      };
    }

    case types.FETCH_REVIEW_COUNTRY:
      return {
        ...state,
        reviewCountriesStatus: true,
        reviewCountries: [],
      };
    case types.FETCH_REVIEW_COUNTRY_SUCCESS: {
      return {
        ...state,
        reviewCountriesStatus: false,
        reviewCountries: action.payload,
      };
    }
    case types.FETCH_REVIEW_COUNTRY_FAILED: {
      return {
        ...state,
        reviewCountriesStatus: false,
        reviewCountries: [],
      };
    }

    case types.FETCH_BRANCH:
      return {
        ...state,
        branchesForReviewsStatus: true,
        branchesForReviews: [],
      };
    case types.FETCH_BRANCH_SUCCESS: {
      return {
        ...state,
        branchesForReviewsStatus: false,
        branchesForReviews: action.payload,
      };
    }
    case types.FETCH_BRANCH_FAILED: {
      return {
        ...state,
        branchesForReviewsStatus: false,
        branchesForReviews: [],
      };
    }

    case types.FETCH_COUNTRY:
      return {
        ...state,
        countryStatus: true,
        countries: [],
      };
    case types.FETCH_COUNTRY_SUCCESS: {
      return {
        ...state,
        countryStatus: false,
        countries: action.payload,
      };
    }
    case types.FETCH_COUNTRY_FAILED: {
      return {
        ...state,
        countryStatus: false,
        countries: [],
      };
    }

    case types.FETCH_REVIEW_FILTER:
      return {
        ...state,
        reviewModerationStatus: true,
        reviewForModeration: [],
      };
    case types.FETCH_REVIEW_FILTER_SUCCESS: {
      return {
        ...state,
        reviewModerationStatus: false,
        reviewForModeration: action.payload,
      };
    }
    case types.FETCH_REVIEW_FILTER_FAILED: {
      return {
        ...state,
        reviewModerationStatus: false,
        reviewForModeration: [],
      };
    }

    case types.FETCH_STATE:
      return {
        ...state,
        stateStatus: true,
        states: [],
      };
    case types.FETCH_STATE_SUCCESS: {
      return {
        ...state,
        stateStatus: false,
        states: action.payload,
      };
    }
    case types.FETCH_STATE_FAILED: {
      return {
        ...state,
        stateStatus: false,
        states: [],
      };
    }

    case types.FETCH_CITY:
      return {
        ...state,
        cityStatus: true,
        cities: [],
      };
    case types.FETCH_CITY_SUCCESS: {
      return {
        ...state,
        cityStatus: false,
        cities: action.payload,
      };
    }
    case types.FETCH_CITY_FAILED: {
      return {
        ...state,
        cityStatus: false,
        cities: [],
      };
    }

    case types.CREATE_RIDES:
      return {
        ...state,
        createRideStatus: true,
      };

    case types.CREATE_RIDES_SUCCESS: {
      return {
        ...state,
        createRideStatus: false,
      };
    }

    case types.CREATE_RIDES_FAILED: {
      return {
        ...state,
        createRideStatus: false,
      };
    }

    case types.UPDATE_RIDES:
      return {
        ...state,
        updateRideStatus: true,
      };

    case types.UPDATE_RIDES_SUCCESS: {
      return {
        ...state,
        updateRideStatus: false,
      };
    }

    case types.UPDATE_RIDES_FAILED: {
      return {
        ...state,
        updateRideStatus: false,
      };
    }

    case types.DELETE_RIDES:
      return {
        ...state,
        deleteRideStatus: true,
      };

    case types.DELETE_RIDES_SUCCESS: {
      return {
        ...state,
        deleteRideStatus: false,
      };
    }

    case types.DELETE_RIDES_FAILED: {
      return {
        ...state,
        deleteRideStatus: false,
      };
    }

    case types.FETCH_CONSENT_FORM:
      return {
        ...state,
        consentFormStatus: true,
        consentForm: null,
      };

    case types.FETCH_CONSENT_FORM_SUCCESS: {
      return {
        ...state,
        consentFormStatus: false,
        consentForm: action.payload,
      };
    }

    case types.FETCH_CONSENT_FORM_FAILED: {
      return {
        ...state,
        consentFormStatus: false,
        consentForm: null,
      };
    }

    case types.MODERATION_OF_RIDES:
      return {
        ...state,
        moderateRidesStatus: true,
      };

    case types.MODERATION_OF_RIDES_SUCCESS: {
      return {
        ...state,
        moderateRidesStatus: false,
      };
    }

    case types.MODERATION_OF_RIDES_FAILED: {
      return {
        ...state,
        moderateRidesStatus: false,
      };
    }

    case types.FETCH_RIDES_FOR_MODERATION:
      return {
        ...state,
        ridesForModerationStatus: true,
        ridesForModeration: [],
      };
    case types.FETCH_RIDES_FOR_MODERATION_SUCCESS: {
      return {
        ...state,
        ridesForModerationStatus: false,
        ridesForModeration: action.payload,
      };
    }
    case types.FETCH_RIDES_FOR_MODERATION_FAILED: {
      return {
        ...state,
        ridesForModerationStatus: false,
        ridesForModeration: [],
      };
    }

    case types.FETCH_REVIEW_FOR_MODERATION:
      return {
        ...state,
        reviewForModerationStatus: true,
        reviewForModeration: [],
      };
    case types.FETCH_REVIEW_FOR_MODERATION_SUCCESS: {
      return {
        ...state,
        reviewForModerationStatus: false,
        reviewForModeration: action.payload,
      };
    }
    case types.FETCH_REVIEW_FOR_MODERATION_FAILED: {
      return {
        ...state,
        reviewForModerationStatus: false,
        reviewForModeration: [],
      };
    }

    case types.FETCH_USER_TO_JOIN_RIDE:
      return {
        ...state,
        usersToJoinRideStatus: true,
        usersToJoinRide: [],
      };
    case types.FETCH_USER_TO_JOIN_RIDE_SUCCESS: {
      return {
        ...state,
        usersToJoinRideStatus: false,
        usersToJoinRide: action.payload,
      };
    }
    case types.FETCH_USER_TO_JOIN_RIDE_FAILED: {
      return {
        ...state,
        usersToJoinRideStatus: false,
        usersToJoinRide: [],
      };
    }

    case types.MODERATION_FOR_USER_RIDE:
      return {
        ...state,
        moderationStatusForUser: true,
      };
    case types.MODERATION_FOR_USER_RIDE_SUCCESS: {
      return {
        ...state,
        moderationStatusForUser: false,
      };
    }
    case types.MODERATION_FOR_USER_RIDE_FAILED: {
      return {
        ...state,
        moderationStatusForUser: false,
      };
    }

    case types.JOIN_NEW_USER:
      return {
        ...state,
        joinNewUserStatus: true,
      };
    case types.JOIN_NEW_USER_SUCCESS: {
      return {
        ...state,
        joinNewUserStatus: false,
      };
    }
    case types.JOIN_NEW_USER_FAILED: {
      return {
        ...state,
        joinNewUserStatus: false,
      };
    }

    case types.FETCH_ALL_USERS:
      return {
        ...state,
        allUserStatus: true,
        allUser: [],
      };
    case types.FETCH_ALL_USERS_SUCCESS: {
      return {
        ...state,
        allUserStatus: false,
        allUser: action.payload,
      };
    }
    case types.FETCH_ALL_USERS_FAILED: {
      return {
        ...state,
        allUserStatus: false,
        allUser: [],
      };
    }

    case types.EXPORT_TO_EXCEL:
      return {
        ...state,
        exportToExcelStatus: true,
      };
    case types.EXPORT_TO_EXCEL_SUCCESS: {
      return {
        ...state,
        exportToExcelStatus: false,
      };
    }
    case types.EXPORT_TO_EXCEL_FAILED: {
      return {
        ...state,
        exportToExcelStatus: false,
      };
    }

    case types.EXPORT_TO_EXCEL_FOR_REVIEW:
      return {
        ...state,
        exportToExcelForReviewStatus: true,
      };
    case types.EXPORT_TO_EXCEL_FOR_REVIEW_SUCCESS: {
      return {
        ...state,
        exportToExcelForReviewStatus: false,
      };
    }
    case types.EXPORT_TO_EXCEL_FOR_REVIEW_FAILED: {
      return {
        ...state,
        exportToExcelForReviewStatus: false,
      };
    }

    case types.FETCH_IMAGES_FOR_MODERATION:
      return {
        ...state,
        rideImagesForModerationStatus: true,
        rideImagesForModeration: [],
      };
    case types.FETCH_IMAGES_FOR_MODERATION_SUCCESS: {
      return {
        ...state,
        rideImagesForModerationStatus: false,
        rideImagesForModeration: action.payload,
      };
    }
    case types.FETCH_IMAGES_FOR_MODERATION_FAILED: {
      return {
        ...state,
        rideImagesForModerationStatus: false,
        rideImagesForModeration: [],
      };
    }

    case types.FETCH_FILTER_IMAGE_FOR_MODERATION:
      return {
        ...state,
        rideImagesForModerationStatus: true,
        rideImagesForModeration: [],
      };
    case types.FETCH_FILTER_IMAGE_FOR_MODERATION_SUCCESS: {
      return {
        ...state,
        rideImagesForModerationStatus: false,
        rideImagesForModeration: action.payload[0].images,
      };
    }
    case types.FETCH_FILTER_IMAGE_FOR_MODERATION_FAILED: {
      return {
        ...state,
        rideImagesForModerationStatus: false,
        rideImagesForModeration: [],
      };
    }

    case types.FETCH_COUNTRY_IMAGE_FOR_MODERATION:
      return {
        ...state,
        rideImagesCountriesStatus: true,
        rideImageCountries: [],
      };
    case types.FETCH_COUNTRY_IMAGE_FOR_MODERATION_SUCCESS: {
      return {
        ...state,
        rideImagesCountriesStatus: false,
        rideImageCountries: action.payload,
      };
    }
    case types.FETCH_COUNTRY_IMAGE_FOR_MODERATION_FAILED: {
      return {
        ...state,
        rideImagesCountriesStatus: false,
        rideImageCountries: [],
      };
    }

    case types.FETCH_BRANCH_IMAGE_FOR_MODERATION:
      return {
        ...state,
        rideImagesBranchesStatus: true,
        rideImageBranches: [],
      };
    case types.FETCH_BRANCH_IMAGE_FOR_MODERATION_SUCCESS: {
      return {
        ...state,
        rideImagesBranchesStatus: false,
        rideImageBranches: action.payload,
      };
    }
    case types.FETCH_BRANCH_IMAGE_FOR_MODERATION_FAILED: {
      return {
        ...state,
        rideImagesBranchesStatus: false,
        rideImageBranches: [],
      };
    }

    case types.MODERATED_IMAGES:
      return {
        ...state,
        moderateImage: null,
        moderateImageStatus: true,
      };
    case types.MODERATED_IMAGES_SUCCESS: {
      return {
        ...state,
        moderateImage: action.payload,
        moderateImageStatus: false,
      };
    }
    case types.MODERATED_IMAGES_FAILED: {
      return {
        ...state,
        moderateImage: null,
        moderateImageStatus: false,
      };
    }

    case types.UPDATE_RIDE_BY_ADMIN:
      return {
        ...state,
        updateRideStatus: true,
      };

    case types.UPDATE_RIDE_BY_ADMIN_SUCCESS: {
      return {
        ...state,
        updateRideStatus: false,
      };
    }

    case types.UPDATE_RIDE_BY_ADMIN_FAILED: {
      return {
        ...state,
        updateRideStatus: false,
      };
    }

    case types.ACTIVITY_FOR_REVIEW:
      return {
        ...state,
        activityForReview: [],
      };

    case types.ACTIVITY_FOR_REVIEW_SUCCESS: {
      return {
        ...state,
        activityForReview: action.payload,
      };
    }

    case types.ACTIVITY_FOR_REVIEW_FAILED: {
      return {
        ...state,
        activityForReview: [],
      };
    }

    case types.ACTIVITY_FOR_GALLERY:
      return {
        ...state,
        activityForGallery: [],
      };

    case types.ACTIVITY_FOR_GALLERY_SUCCESS: {
      return {
        ...state,
        activityForGallery: action.payload,
      };
    }

    case types.ACTIVITY_FOR_GALLERY_FAILED: {
      return {
        ...state,
        activityForGallery: [],
      };
    }

    case types.MODERATION_OF_RIDE_GALLERY:
      return {
        ...state,
        moderateRideGalleyStatus: true,
      };

    case types.MODERATION_OF_RIDE_GALLERY_SUCCESS: {
      return {
        ...state,
        moderateRideGalleyStatus: false,
      };
    }

    case types.MODERATION_OF_RIDE_GALLERY_FAILED: {
      return {
        ...state,
        moderateRideGalleyStatus: false,
      };
    }

    default:
      return state;
  }
}

export default ridesReducers;
